import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../components/common";
import RemindMeSection from "../components/travel/RemindMeSection";
import AuthModal from "../components/AuthModal";
import { useState } from "react";

/* Standalone /remind-me page — free for all signed-in users, part of My Social Pulse. */
export default function RemindMe() {
  const { user, loading } = useAuth();
  const [showAuth, setShowAuth] = useState(false);
  if (loading) return <Spinner full />;
  if (!user) {
    return (
      <div className="max-w-3xl mx-auto px-5 py-16 text-center" data-testid="remindme-signin-prompt">
        <h1 className="font-heading font-900 text-3xl mb-3">Remind Me</h1>
        <p className="text-muted-foreground mb-6">Sign in to set reminders with custom alerts, images and links.</p>
        <button onClick={() => setShowAuth(true)} data-testid="remindme-signin-btn"
          className="bg-amber-600 text-white px-6 py-2.5 font-700 hover:bg-amber-700">Sign in</button>
        {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
      </div>
    );
  }
  return (
    <div className="max-w-5xl mx-auto px-5 lg:px-8 py-8" data-testid="remindme-page">
      <Link to="/my-social-pulse" className="inline-flex items-center gap-1 text-sm text-indigo-700 font-700 hover:underline mb-4" data-testid="remindme-back-hub">
        <ChevronLeft className="w-4 h-4" /> My Social Pulse
      </Link>
      <RemindMeSection />
    </div>
  );
}
